enum TypeEnum {
    RealEstate = 'REAL_ESTATE',
    Accountant = 'ACCOUNTANT',
    Leads = 'LEADS',
    Lender = 'LENDER',
    Other = 'OTHER',
}

export default TypeEnum;
